import React from 'react'

export default function Feactures() {
  return (
    <div>Feactures</div>
  )
}
